import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Button, Typography} from 'views/components';
import {Dialog, DialogActions, DialogContent, DialogTitle} from 'views/components';

import {Translate} from 'views/module';

import Backend from 'utils/backend';

const DeactivateUser = (props) => {
  const [isSaving, setIsSaving] = React.useState(false);

  const {
    userRn,
  } = props;

  const progressWrap = props.statusProgressWrap;
  const closeModel = props.closeModel;

  const onSave = (e) => {
    e.preventDefault();
    setIsSaving(true);
    progressWrap(async () => {
      await Backend.user.deactivateUser(userRn);
      closeModel(true);
    });
  };

  const onClose = () => {
    closeModel(false);
  };

  return (
    <Dialog onClose={onClose}>
      <DialogTitle onClose={onClose}>
        <Translate expression='generic.ConfirmTheAction'/>
      </DialogTitle>
      <DialogContent>
        <Typography>
          <Translate expression='generic.DeleteConfirm'/>
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' onClick={onClose}>
          <Translate expression='generic.Cancel'/>
        </Button>
        <Button onClick={onSave} disabled={isSaving}>
          <Translate expression='generic.Confirm'/>
        </Button>
      </DialogActions>
    </Dialog>
  );
};

DeactivateUser.propTypes = {
  userRn: PropTypes.string.isRequired,
  closeModel: PropTypes.func.isRequired,
  statusProgressWrap: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(DeactivateUser));

